<nav class="vsf-mobile-bottom-nav" role="navigation" aria-label="Mobile bottom navigation" *transloco="let t; prefix: 'mix'">
  <button type="button" class="nav-item" (click)="openKatalog()" aria-label="Katalog">
    <div class="pi pi-bars icon"></div>
    <span class="label">{{ t('katalog') }}</span>
  </button>

    @if ((activeCustomer$ | async); as customer) {
        <a class="nav-item" [routerLink]="['/account/orders']" aria-label="Account">
            <div class="pi pi-user icon"></div>
            <span class="label">{{ userName(customer) }}</span>
        </a>
    } @else {
        <a class="nav-item" [routerLink]="['/account/sign-in']" aria-label="Account">
            <div class="pi pi-user icon"></div>
            <span class="label">{{ t('account') }}</span>
        </a>
    }
  <a class="nav-item" [routerLink]="['/account/wishlist']" aria-label="Wishlist">
    <div class="relative">
      <div class="pi pi-heart icon"></div>

      @if ((wishlistItemCount$ | async); as count) {
        <span
          [class.opacity-0]="count === 0"
          class="absolute -top-1 -right-1 
                rounded-full w-[13px] h-[13px] 
                flex items-center justify-center 
                bg-[#ff4141] text-white text-[10px] font-semibold"
        >
          {{ count }}
        </span>
      }
    </div>

    <span class="label">{{ t('wishlist') }}</span>
  </a>
</nav>
 